module.exports = __webpack_public_path__ + "img/3.82ce9e0b.jpg";